import * as VisuallyHidden from '@radix-ui/react-visually-hidden'
import {
  Sheet,
  SheetContent,
  SheetTitle,
} from '@/components/ui/sheet'
import { CreateTaskSheetContent } from './CreateTaskSheetContent'

// Right-side sheet wrapper for "Nouvelle tâche" on the My Tasks index.
// Inner form lives in CreateTaskSheetContent so TaskDetailSheet can
// reuse it for its in-place subtask-create mode.

interface CreateTaskSheetProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onCreated: (taskId: number) => void
}

export function CreateTaskSheet({ open, onOpenChange, onCreated }: CreateTaskSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        className="w-[700px] sm:max-w-[700px] overflow-y-auto p-0"
        aria-describedby={undefined}
      >
        <VisuallyHidden.Root>
          <SheetTitle>Nouvelle tâche</SheetTitle>
        </VisuallyHidden.Root>

        {open && (
          // Inner wrapper carries the padding so TaskDetailSheet's
          // sibling layout stays consistent (both use p-6 inside a
          // p-0 SheetContent). Without this the form sat flush against
          // the sheet edges.
          <div className="p-6">
            <CreateTaskSheetContent
              onCreated={onCreated}
              onCancel={() => onOpenChange(false)}
            />
          </div>
        )}
      </SheetContent>
    </Sheet>
  )
}
